export default __webpack_public_path__ + "static/media/1957.3cb87e40.png";